module.exports = __webpack_public_path__ + "img/biatic.f72afeb8.png";